// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"js","contentFrame":"jt","buttonGroup":"ju","button":"jv","header":"jw","text":"jx","contentImage":"jy","closeButton":"jz"};